export default __webpack_public_path__ + "static/media/icon-schoolwide.7d97c3a9.svg";